import React, { Component } from "react";

import WorkspaceController from "../../../controllers/WorkspaceController";
import AppController from "../../../core/AppController";
import { stopPropagation } from "../../../core/utilities/stopPropagation";
import PresentationEditorController from "../../../editor/PresentationEditor/PresentationEditorController";
import { PropertyPanelContainer } from "../../../EditorComponents/PropertyPanel";
import { PropertyPanelButton } from "../../../EditorComponents/PropertyPanelButton";
import { ShowDialog, ShowWarningDialog } from "../../../react/components/Dialogs/BaseDialog";
import { PropertyPanelHeader } from "../../ElementEditor/PropertyPanelHeader";
import { ActionPermissionsObject, PermissionActionType, WorkspacePlanTier } from "../../../../common/interfaces";
import ChangePlanDialog from "js/react/components/Dialogs/ChangePlanDialog";

export const StylePanel = AppController.withState(class StylePanel extends Component {
    handleEditTheme = async (teamThemeClicked = false) => {
        const { presentation } = this.props;

        if (teamThemeClicked && WorkspaceController.canUpgradeToRemoveActionRestriction(ActionPermissionsObject.SHARED_RESOURCES, PermissionActionType.MANAGE)) {
            ShowDialog(ChangePlanDialog,
                {
                    featuredPlan: WorkspacePlanTier.TEAM,
                    analytics: { cta: "edit_team_theme_from_presentation" }
                });

            return;
        }

        const isTeamTheme = presentation.has("sharedThemeId");
        if (isTeamTheme && !WorkspaceController.actionPermissions[ActionPermissionsObject.SHARED_RESOURCES].manage) {
            ShowWarningDialog({
                title: "Sorry, you don't have permission to edit this Team Theme.",
                message: "Team Themes are shared and only editable by team Owners and Librarians.",
                acceptButtonText: "Got it"
            });
            return;
        }

        await PresentationEditorController.showThemeEditor();
    }

    handleSwitchTheme = () => {
        PresentationEditorController.showSwitchThemeDialog();
    }

    render() {
        const { presentation, isSingleSlideEditor } = this.props;

        const isTeamTheme = presentation.has("sharedThemeId");
        const errorLoadingSharedTheme = presentation.has("errorLoadingSharedTheme");
        const canEditTheme = isTeamTheme
            ? WorkspaceController.actionPermissions[ActionPermissionsObject.SHARED_RESOURCES].manage
            : true;
        const canUpgradeToEditTeamTheme = WorkspaceController.canUpgradeToRemoveActionRestriction(ActionPermissionsObject.SHARED_RESOURCES, PermissionActionType.MANAGE);

        return (
            <PropertyPanelContainer fullHeight>
                <PropertyPanelHeader>Styles</PropertyPanelHeader>
                {errorLoadingSharedTheme && (
                    <PropertyPanelButton
                        title="Edit Theme..."
                        icon="palette"
                        description="Theme missing, switch to a new theme before editing."
                        onMouseDown={stopPropagation()}
                        onClick={() => ShowWarningDialog({
                            title: "Missing Theme",
                            message: <>
                                The theme used in this presentation is missing and your slides may look different. <br />
                                Switch to another theme to continue editing.
                            </>,
                            acceptButtonText: "Got It"
                        })}
                    />
                )}

                {!isTeamTheme && !isSingleSlideEditor && !errorLoadingSharedTheme && (
                    <PropertyPanelButton
                        title="Edit Theme..."
                        icon="palette"
                        description="Edit the current theme for this presentation."
                        onClick={this.handleEditTheme}
                        onMouseDown={stopPropagation()}
                    />
                )}
                {!errorLoadingSharedTheme &&
                    ((isTeamTheme && !isSingleSlideEditor) || canUpgradeToEditTeamTheme) &&
                    (
                        <PropertyPanelButton
                            title="Edit Team Theme..."
                            icon={canUpgradeToEditTeamTheme ? "upgrade" : "link"}
                            description={canEditTheme ? "Edit team theme." : "Only Team Librarians and Members can edit shared team themes."}
                            iconBackdropColor={!canEditTheme ? "red" : "transparent"}
                            onClick={() => this.handleEditTheme(true)}
                            onMouseDown={stopPropagation()}
                        />
                    )}
                <PropertyPanelButton
                    title="Switch Theme..."
                    icon="cycle"
                    description="Switch this presentation to another theme."
                    onClick={this.handleSwitchTheme}
                    onMouseDown={stopPropagation()}
                />
            </PropertyPanelContainer>
        );
    }
});
